/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchangeplace3Inputs */

const en_aiflowchangeplace3 = /** @type {(inputs: Aiflowchangeplace3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the place`)
};

const de_aiflowchangeplace3 = /** @type {(inputs: Aiflowchangeplace3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort ändern`)
};

/**
* | output |
* | --- |
* | "Change the place" |
*
* @param {Aiflowchangeplace3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchangeplace3 = /** @type {((inputs?: Aiflowchangeplace3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchangeplace3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchangeplace3(inputs)
	return de_aiflowchangeplace3(inputs)
});
export { aiflowchangeplace3 as "aiFlowChangePlace" }